import React, { useEffect, useState } from "react";
import { IMedicalRecordImagesList } from "../../../models/response/ISMRResponse";
import LoaderButton from "../../../shared-components/button/loader-button";
import { formatMessage } from "../../../translations/format-message";
import { FormattedMessage, injectIntl, WrappedComponentProps } from "react-intl";
interface IProps extends WrappedComponentProps {
  initialValue: string;
  rows: number;
  disabled: boolean;
  submitHandler: (value: any) => void;
}
const ReservationMemoCard = (props: IProps) => {
  const { initialValue, rows, submitHandler, disabled } = props;
  const [data, setData] = useState<string>(initialValue);
  const [err, setErr] = useState<string>("");
  const [isEditMode, setIsEditMode] = useState<boolean>(false);

  return (
    <div className="border p-3">
      <div className="d-flex justify-content-between align-items-center mb-2">
        <h3 className="mb-0">{formatMessage("reservation_memo")}</h3>
        <div className="text-end">
          {!disabled && (
            <>
              {!isEditMode ? (
                <LoaderButton
                  type="button"
                  className="btn-sm"
                  iconName="bi-pencil-fill"
                  text="button_edit"
                  onClick={() => {
                    setIsEditMode(true);
                  }}
                />
              ) : (
                <LoaderButton
                  type="button"
                  className="btn-sm"
                  iconName="bi-check-lg"
                  onClick={() => {
                    let trimmedData = data?.trim();
                    if(trimmedData?.length > 256){
                      setErr("max_256_characters");
                    }
                    else{
                      setErr("");
                      submitHandler(trimmedData);
                      setIsEditMode(false);
                    }
                  }}
                  text="button_save"
                />
              )}
            </>
          )}
        </div>
      </div>
      <div className="reservation_textarea">
        <textarea
          value={data}
          disabled={!isEditMode}
          rows={rows}
          onChange={(event) => {
            let value = event.target.value;
            if(value?.length > 256){
              setErr("max_256_characters");
            }
            else{
              setErr("");
            }
            setData(value);
          }}
        />
        {
          err &&
          <span data-testid="testError" className="text-danger errorMessage"><FormattedMessage id={err} /></span>
        }
      </div>
    </div>
  );
};

export default injectIntl(ReservationMemoCard);
